import React from 'react';
import styled, { keyframes } from 'styled-components';

const LoaderOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const LoaderContainer = styled.div`
  text-align: center;
`;

// Section Loader styles - for localized loading within a specific section
const SectionLoaderContainer = styled.div`
  position: relative;
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  50% { transform: translateX(20%); }
  100% { transform: translateX(100%); }
`;

const BarWrapper = styled.div`
  width: 100%;
  max-width: 360px;
  height: 6px;
  border-radius: 999px;
  background: #f1f1f1;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
`;

const Bar = styled.div`
  width: 40%;
  height: 100%;
  background: linear-gradient(90deg, rgba(213, 41, 0, 0.1), #d52900, rgba(213, 41, 0, 0.1));
  animation: ${shimmer} 1.1s ease-in-out infinite;
  border-radius: 999px;
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #d52900;
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
  margin: 0 auto;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.div`
  margin-top: 1rem;
  color: #d52900;
  font-size: 1.1rem;
  font-weight: 500;
`;

interface FullScreenLoaderProps {
  isLoading: boolean;
  message?: string;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ isLoading, message = "Loading..." }) => {
  if (!isLoading) return null;

  return (
    <LoaderOverlay>
      <LoaderContainer>
        <Spinner />
        <LoadingText>{message}</LoadingText>
      </LoaderContainer>
    </LoaderOverlay>
  );
};

interface SectionLoaderProps {
  isLoading: boolean;
  message?: string;
}

export const SectionLoader: React.FC<SectionLoaderProps> = ({ isLoading, message = "Loading..." }) => {
  if (!isLoading) return null;

  return (
    <SectionLoaderContainer>
      <LoaderContainer>
        <BarWrapper aria-hidden="true">
          <Bar />
        </BarWrapper>
        <LoadingText>{message}</LoadingText>
      </LoaderContainer>
    </SectionLoaderContainer>
  );
};

export default FullScreenLoader;